import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image-processer" }
const _hoisted_2 = { class: "image-cropper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "image-process" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_styled_uploader = _resolveComponent("styled-uploader")!
  const _component_ScissorOutlined = _resolveComponent("ScissorOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showModal) = $event)),
      title: "裁剪图片",
      "ok-text": "确认",
      "cancel-text": "取消",
      onOk: _ctx.handleOk,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            id: "processed-image",
            ref: "cropperImg",
            src: _ctx.baseImageUrl
          }, null, 8, _hoisted_3)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createElementVNode("div", {
      class: _normalizeClass(["image-preview", { extraHeight: _ctx.showDelete }]),
      style: _normalizeStyle({ backgroundImage: _ctx.backgrondUrl })
    }, null, 6),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_styled_uploader, { onSuccess: _ctx.handleFileUploaded }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "w-full inline-flex items-center",
            shape: "round"
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_UploadOutlined)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 更换图片 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSuccess"]),
      _createVNode(_component_a_button, {
        shape: "round",
        class: "inline-flex items-center",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = true))
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_ScissorOutlined)
        ]),
        default: _withCtx(() => [
          _createTextVNode("裁剪图片 ")
        ]),
        _: 1
      }),
      (_ctx.showDelete)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "danger",
            class: "inline-flex items-center",
            shape: "round",
            onClick: _ctx.handleDelete
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_DeleteOutlined)
            ]),
            default: _withCtx(() => [
              _createTextVNode("删除图片 ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}